import * as yup from 'yup';

const MAX_FILE_SIZE = 2 * 1024 * 1024;

export const uploadBatchDialogSchema = yup
  .object({
    name: yup.string().optional(),
    file: yup
      .mixed<FileList>()
      .label('file')
      .test('file-required', 'File required', (value) => {
        if (!value) return false;
        return value.length > 0;
      })
      .test(
        'file-not-empty',
        'File seems to be empty. Please try again.',
        (value) => {
          if (!(value instanceof FileList) || value.length === 0) return true;
          const file = value.item(0);
          if (!file) return true;
          return file.size > 0;
        }
      )
      .test(
        'file-size',
        'The file is too large. Please try again.',
        (value) => {
          if (!(value instanceof FileList) || value.length === 0) return true;
          const file = value.item(0);
          if (!file) return true;
          return file.size <= MAX_FILE_SIZE;
        }
      )
  })
  .required();
